"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSimpleAnimation = exports.keyFramePresets = exports.CreatePixiPropSetter = exports.AnimationManager = void 0;
const Utils_1 = require("../../Utils/Utils");
const GameEvent_1 = require("../GameEvent");
const BezierCurve_1 = require("./BezierCurve");
const WarnedAnim = new WeakMap();
const bezierCalc = new WeakMap();
const binarySearchTime = Utils_1.createBinarySearch((lname, iname) => `${lname}[${iname}].time`);
function CalcAnimation(anim, time) {
    if (anim.loop || anim.yoyo) {
        const t = (time / anim.totaltime) | 0;
        time -= anim.totaltime * t;
        if (anim.yoyo && t % 2)
            time = anim.totaltime - time;
    }
    const list = anim.keyframes;
    if (list.length === 0) {
        if (!WarnedAnim.get(anim)) {
            WarnedAnim.set(anim, 1);
            console.warn("Empty animation");
        }
        return 0;
    }
    const i = binarySearchTime(list, time);
    if (i === list.length - 1)
        return list[i].value;
    if (i === -1)
        return list[0].value;
    const start = list[i];
    const end = list[i + 1];
    switch (start.type) {
        case "static":
            return start.value;
        case "linear":
            return Utils_1.ratio(start.time, end.time, time, start.value, end.value);
        case "bezier": {
            let calc = bezierCalc.get(start.ctrl);
            if (!calc) {
                calc = BezierCurve_1.CreateBezierCurve(start.ctrl);
                bezierCalc.set(start.ctrl, calc);
            }
            const t = calc((time - start.time) / (end.time - start.time));
            return (end.value - start.value) * t + start.value;
        }
    }
}
class AnimationManager {
    constructor(setter) {
        this.currentTime = 0;
        this.animations = new Map();
        this.onEnd = new GameEvent_1.GameEvent();
        this.paused = false;
        this._ended = false;
        this.propSetter = setter;
    }
    /**
     * @param dt in seconds
     */
    update(dt) {
        if (this.paused)
            return;
        this.currentTime += dt;
        let endcount = 0;
        if (this.propSetter) {
            for (const [prop, anim] of this.animations) {
                const origvalue = CalcAnimation(anim, this.currentTime);
                const value = origvalue * (typeof anim.scale === "number" ? anim.scale : 1) +
                    (typeof anim.base === "number" ? anim.base : 0);
                if (this.propSetter[prop])
                    this.propSetter[prop](value);
                if (!anim.loop && !anim.yoyo && this.currentTime >= anim.totaltime)
                    endcount++;
            }
        }
        if (endcount === this.animations.size) {
            if (!this._ended)
                this.onEnd.emit();
            this._ended = true;
        }
        else {
            this._ended = false;
        }
    }
    get ended() {
        return this._ended;
    }
}
exports.AnimationManager = AnimationManager;
function CreatePixiPropSetter(obj) {
    const s = obj;
    return {
        x: v => (s.x = v),
        y: v => (s.y = v),
        alpha: v => (s.alpha = v),
        rotation: v => (s.rotation = v),
        angle: v => (s.angle = v),
        scale: v => s.scale.set(v),
        scalex: v => (s.scale.x = v),
        scaley: v => (s.scale.y = v),
        r: v => (s.tint = Utils_1.setByte(s.tint, 2, v)),
        g: v => (s.tint = Utils_1.setByte(s.tint, 1, v)),
        b: v => (s.tint = Utils_1.setByte(s.tint, 0, v)),
    };
}
exports.CreatePixiPropSetter = CreatePixiPropSetter;
exports.keyFramePresets = {
    linear: {
        type: "linear",
        time: 0,
        value: 0,
    },
    easeInOUt: {
        type: "bezier",
        ctrl: [0.42, 0, 0.58, 1],
        time: 0,
        value: 0,
    },
    easeIn: {
        type: "bezier",
        ctrl: [0.42, 0, 1, 1],
        time: 0,
        value: 0,
    },
    easeOut: {
        type: "bezier",
        ctrl: [0, 0, 0.58, 1],
        time: 0,
        value: 0,
    },
};
function createSimpleAnimation(from, to, time, keyframe) {
    return {
        keyframes: [
            keyframe,
            {
                type: "linear",
                time,
                value: 1,
            },
        ],
        totaltime: time,
        base: from,
        scale: to - from,
    };
}
exports.createSimpleAnimation = createSimpleAnimation;
//# sourceMappingURL=Animation.js.map